<template>
    <div>

        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
         </div>

         <div class="formulario">
              <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                  <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Conta principal'" :TipoCliente="'Fundos'" :Sessao="'Dados Bancários'" :SubSessao="'Conta Principal'"/>
                </div>
                <div class="camposAgrupamentoFormulario">

                  <div class="row">
                    <div class="label__field" style="width: 60%">
                      <label class="label" for="nome">Banco*</label>
                      <select id="bancoContaPrincipal"   @change="salvarAlteracoesLocalmente" class="field" v-model="dadosBancariosContaPrincipal.NomeBanco">
                        <option value="">Selecione</option>
                        <option v-for="item in listaBancos" :key="item.Codigo"  :value="item.Codigo">
                              {{ item.Codigo + ' - ' + item.Descricao }}
                        </option>
                      </select>
 <p v-if="camposObrigatorios.erroNomeBancoPrincipal" class="erro">
      Campo obrigatório.
 </p>
                    </div>

                  </div>


                  <div class="row">
                    <div class="label__field" style="width: 25%">
                      <label class="label" for="nome">Agência*</label>
                      <input class="field" type="text" @change="salvarAlteracoesLocalmente" v-model="dadosBancariosContaPrincipal.Agencia" id="agenciaPrincipal" placeholder="">
 <p v-if="camposObrigatorios.erroAgenciaPrincipal" class="erro">
      Campo obrigatório.
 </p>
                    </div>

                     <div class="label__field" style="width: 25%">
                      <label class="label" for="nome">Dígito</label>
                      <input class="field" type="text" @change="salvarAlteracoesLocalmente" v-model="dadosBancariosContaPrincipal.DigitoAgencia" id="agenciaDigitoPrincipal" placeholder="">

                    </div>


                    <div class="label__field" style="width: 25%">
                      <label class="label" for="nome">Conta*</label>
                      <input class="field" type="text" @change="salvarAlteracoesLocalmente" v-model="dadosBancariosContaPrincipal.ContaCorrente" id="contaCorrentePrincipal" placeholder="">
 <p v-if="camposObrigatorios.erroContaCorrentePrincipal" class="erro">
      Campo obrigatório.
 </p>
                    </div>

                    <div class="label__field" style="width: 25%">
                      <label class="label" for="nome">Dígito*</label>
                      <input class="field" type="text" @change="salvarAlteracoesLocalmente" v-model="dadosBancariosContaPrincipal.DigitoContaCorrente" id="contaCorrenteDigitoPrincipal" placeholder="">
 <p v-if="camposObrigatorios.erroDigitoContaCorrentePrincipal" class="erro">
      Campo obrigatório.
 </p>
                    </div>

                  </div>




                </div>
              </div>
              

              <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                  <h5>Conta adicional</h5>
                </div>
                <div class="camposAgrupamentoFormulario">

                  <div class="row">
                    <div class="label__field" style="width: 60%">
                      <label class="label" for="nome">Banco*</label>
                      <select id="bancoContaAdicional"   @change="salvarAlteracoesLocalmenteAdicional" class="field" v-model="dadosBancariosContaAdicional.NomeBanco">
                        <option value="">Selecione</option>
                        <option v-for="item in listaBancos" :key="item.Codigo"  :value="item.Codigo">
                              {{ item.Codigo + ' - ' + item.Descricao }}
                        </option>
                      </select>
 <p v-if="camposObrigatorios.erroNomeBancoAdicional" class="erro">
      Campo obrigatório.
 </p>
                    </div>

                  </div>


                  <div class="row">
                    <div class="label__field" style="width: 25%">
                      <label class="label" for="nome">Agência*</label>
                      <input class="field" type="text"  @change="salvarAlteracoesLocalmenteAdicional" v-model="dadosBancariosContaAdicional.Agencia" id="agenciaAdicional" placeholder="">
 <p v-if="camposObrigatorios.erroAgenciaAdicional" class="erro">
      Campo obrigatório.
 </p>
                    </div>

                     <div class="label__field" style="width: 25%">
                      <label class="label" for="nome">Dígito</label>
                      <input class="field" type="text"  @change="salvarAlteracoesLocalmenteAdicional" v-model="dadosBancariosContaAdicional.DigitoAgencia" id="agenciaDigitoAdicional" placeholder="">

                    </div>


                    <div class="label__field" style="width: 25%">
                      <label class="label" for="nome">Conta*</label>
                      <input class="field" type="text"  @change="salvarAlteracoesLocalmenteAdicional" v-model="dadosBancariosContaAdicional.ContaCorrente" id="contaCorrenteAdicional" placeholder="">
 <p v-if="camposObrigatorios.erroContaCorrenteAdicional" class="erro">
      Campo obrigatório.
 </p>
                    </div>

                    <div class="label__field" style="width: 25%">
                      <label class="label" for="nome">Dígito*</label>
                      <input class="field" type="text"  @change="salvarAlteracoesLocalmenteAdicional" v-model="dadosBancariosContaAdicional.DigitoContaCorrente" id="contaCorrenteDigitoAdicional" placeholder="">
 <p v-if="camposObrigatorios.erroDigitoContaCorrenteAdicional" class="erro">
      Campo obrigatório.
 </p>
                    </div>

                  </div>




                </div>
              </div>

         </div>


    </div>
</template>


<script>

import { mapGetters } from 'vuex';
import LabelDisclaimer from '@/components/LabelDisclaimer.vue'

export default {
    name: 'CadastroOutros_DadosBancarios',
      props: ['Edicao'],
      components: {LabelDisclaimer},
      computed: {
        ...mapGetters({
            user: 'auth/user',
            listaBancos: 'GET_LISTA_BANCOS',
            infoBancarios: 'GET_FI_INFO_BANCARIO',
        }),
    },
    data() {
        return {
          permitirAvancar: false,
          camposObrigatorios: {
            erroNomeBancoPrincipal: false,
            erroAgenciaPrincipal: false,
            erroContaCorrentePrincipal: false,
            erroDigitoContaCorrentePrincipal: false,
            erroNomeBancoAdicional: false,
            erroAgenciaAdicional: false,
            erroContaCorrenteAdicional: false,
            erroDigitoContaCorrenteAdicional: false,
          },
          dadosBancariosContaPrincipal: {
            Guid: '',
            NomeBanco: '',
            Agencia: '',
            DigitoAgencia: '',
            ContaCorrente: '',
            DigitoContaCorrente: '',
            Principal: true
        },
         dadosBancariosContaAdicional: {
            Guid: '',
            NomeBanco: '',
            Agencia: '',
            DigitoAgencia: '',
            ContaCorrente: '',
            DigitoContaCorrente: '',
            Principal: false
        }
      }
    },
    mounted(){

        if(this.infoBancarios.length > 0 && this.infoBancarios[0])
        {
          if(this.infoBancarios[0].Principal){
              this.dadosBancariosContaPrincipal = this.infoBancarios[0];
          }

          if(!this.infoBancarios[0].Principal){
              this.dadosBancariosContaAdicional = this.infoBancarios[0];
          }

          if(this.infoBancarios.length > 1 && this.infoBancarios[1]){
            if(this.infoBancarios[1].Principal){
              this.dadosBancariosContaPrincipal = this.infoBancarios[1];
            }

            if(!this.infoBancarios[1].Principal){
                this.dadosBancariosContaAdicional = this.infoBancarios[1];
            }
          }

        }
        
        this.validarFormulario();

    },
    watch: {
      infoBancarios(){

        if(this.infoBancarios.length > 0)
        {
          if(this.infoBancarios[0].Principal){
              this.dadosBancariosContaPrincipal = this.infoBancarios[0];
          }

          if(!this.infoBancarios[0].Principal){
              this.dadosBancariosContaAdicional = this.infoBancarios[0];
          }

          if(this.infoBancarios.length > 1){
            if(this.infoBancarios[1].Principal){
              this.dadosBancariosContaPrincipal = this.infoBancarios[1];
            }

            if(!this.infoBancarios[1].Principal){
                this.dadosBancariosContaAdicional = this.infoBancarios[1];
            }
          }

        }

        this.validarFormulario();
      }
    },
    methods: {
      validarFormulario(submeter)  {
        this.permitirAvancar = true;
        var nomeDoCampo = '';

        this.camposObrigatorios = {
          erroNomeBancoPrincipal: false,
          erroAgenciaPrincipal: false,
          erroContaCorrentePrincipal: false,
          erroDigitoContaCorrentePrincipal: false,
          erroNomeBancoAdicional: false,
          erroAgenciaAdicional: false,
          erroContaCorrenteAdicional: false,
          erroDigitoContaCorrenteAdicional: false,
        };
        
          if (!this.dadosBancariosContaPrincipal.NomeBanco) {

            if (submeter && this.permitirAvancar) {
              this.camposObrigatorios.erroNomeBancoPrincipal = true;
              nomeDoCampo = 'Banco da conta principal';
            }


            this.permitirAvancar = false;
          }

          if (!this.dadosBancariosContaPrincipal.Agencia) {

            if (submeter && this.permitirAvancar) {
              this.camposObrigatorios.erroAgenciaPrincipal = true;
              nomeDoCampo = 'Agência da conta principal';
            }

            this.permitirAvancar = false;
          }

          if (!this.dadosBancariosContaPrincipal.ContaCorrente) {

            if (submeter && this.permitirAvancar) {
              this.camposObrigatorios.erroContaCorrentePrincipal = true;
              nomeDoCampo = 'Número da conta principal';
            }

            this.permitirAvancar = false;
          }

          if (!this.dadosBancariosContaPrincipal.DigitoContaCorrente) {

            if (submeter && this.permitirAvancar) {
              this.camposObrigatorios.erroDigitoContaCorrentePrincipal = true;
              nomeDoCampo = 'Dígito conta principal';
            }

            this.permitirAvancar = false;
          }

          
            if (submeter && nomeDoCampo != '') {
                  this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo `+ nomeDoCampo +` não foi informado, preencha a informação para avançar.`,
                  });
            }

          if (!this.dadosBancariosContaAdicional.NomeBanco && 
          !this.dadosBancariosContaAdicional.Agencia && 
          !this.dadosBancariosContaAdicional.ContaCorrente &&
          !this.dadosBancariosContaAdicional.DigitoContaCorrente) 
          {
            return this.permitirAvancar;
          }

          if (!this.dadosBancariosContaAdicional.NomeBanco) {

            if (submeter && this.permitirAvancar) {
              this.camposObrigatorios.erroNomeBancoAdicional = true;
              nomeDoCampo = 'Banco da conta adicional';
            }

            this.permitirAvancar = false;
          }

          if (!this.dadosBancariosContaAdicional.Agencia) {

            if (submeter && this.permitirAvancar) {
              this.camposObrigatorios.erroAgenciaAdicional = true;
              nomeDoCampo = 'Agência da conta adicional';
            }

            this.permitirAvancar = false;
          }

          if (!this.dadosBancariosContaAdicional.ContaCorrente) {

           if (submeter && this.permitirAvancar) {
              this.camposObrigatorios.erroContaCorrenteAdicional = true;
              nomeDoCampo = 'Número da conta adicional';
            }

            this.permitirAvancar = false;
          }

          if (!this.dadosBancariosContaAdicional.DigitoContaCorrente) {

           if (submeter && this.permitirAvancar) {
              this.camposObrigatorios.erroDigitoContaCorrenteAdicional = true;
              nomeDoCampo = 'Dígito da conta adicional';
            }

            this.permitirAvancar = false;
          }

            if (submeter && nomeDoCampo != '') {
                  this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo `+ nomeDoCampo +` não foi informado, preencha a informação para avançar.`,
                  });
            }

            return this.permitirAvancar;

      },
      proximaEtapa(){
        if(this.validarFormulario(true))
        {
          this.$store.commit('SET_ETAPA_CADASTRO', 5);
          this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
          this.salvarInformacoes();
        }
      },
      salvarInformacoes(){
        this.$store.commit('SET_FI_SALVAR_INFO', true);
      },
      salvarAlteracoesLocalmente(){
        this.$store.commit('SET_FI_SALVAR_INFO_BANCARIO', this.dadosBancariosContaPrincipal);
        this.validarFormulario();
      },
      salvarAlteracoesLocalmenteAdicional(){
        this.$store.commit('SET_FI_SALVAR_INFO_BANCARIO_ADICIONAL', this.dadosBancariosContaAdicional);
        this.validarFormulario();
      },
    }
}

</script>


<style lang="scss" scoped>

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');


.formulario{
  width: 100%;
}

.agrupamentoFormulario{
  width: 100%;
  display: inline-flex;
  margin-top: 10px;
  border-bottom: 1px solid #D0D5DD; /* Borda */
}

.categoriaAgrupamentoFormulario{
  width: 13%;
  margin-right: 15px;
  font-family: 'Inter', sans-serif; /* Fonte Inter */

  span{
    font-weight: 400 !important;
    font-size: 13px;
    color: #667085;
  }

}

.label__field{
  padding-right: 30px;
}

.camposAgrupamentoFormulario{
  width: 90%;

  .row{
    width: 100%;
    display: inline-flex;
    gap: 8px;
    margin-bottom: 10px;
  }

                  .accept {
                    display: inline-flex;

                    &:checked {
                      +label {
                            &:before {
                                background: white;
                                border: 1px solid black;
                                transition: background 0.3s;
                            }
                        }

                        +label {
                            &::after {
                                opacity: 1;
                                transition: all;
                                background: transparent;
                            }
                        }
                    }
                }

 .field {
    border-radius: 8px; /* Raio de borda */
    border: 1px solid #D0D5DD; /* Borda */
    padding: 10px 14px; /* Preenchimento interno */
    background-color: white; /* Cor de fundo */
    width: 100%;
    /* gap: 8px; - 'gap' não é aplicável diretamente ao input, mas pode ser usado em um container */
}

 .radio {
                display: flex;
                align-items: center;
                margin-right: 25px;

                @media (max-width: 768px) {
                    margin-right: 0;
                    margin-bottom: 20px;
                }

                .field__radio {
                    width: 20px;
                    height: 20px;
                }

                .fieldInRadio{
    border-radius: 8px; /* Raio de borda */
    border: 1px solid #D0D5DD; /* Borda */
    padding: 10px 14px; /* Preenchimento interno */
    background-color: #F9FAFB; /* Cor de fundo */
    width: 55%;
                }

                .label__radio {
                    margin-left: 5px;
                    margin-right: 40px;
                    margin-top: 5px;
                }
            }

select{
  width: 105% !important;
}


label {
    font-family: 'Inter', sans-serif; /* Fonte Inter */
    font-weight: 500; /* Peso médio */
    font-size: 14px; /* Tamanho da fonte */
    line-height: 20px; /* Altura da linha */
    color: #344054; /* Cor */
    display: block; /* Garante que a label fique acima do input */
    margin-bottom: 8px; /* Espaçamento entre a label e o input abaixo dela */
}

}





.title{

  border-bottom: 1px solid #EAECF0;

  h3{
    margin-top: 50px;
    color: #101828;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
    
  }

  h5{
    margin-top: 5px;
    margin-block-start: 0;
    color: #667085;
    font-weight: 400;
    font-family: 'Inter', sans-serif;
  }
}


</style>